import { render, staticRenderFns } from "./JeecgOrderModalForJVexTable.vue?vue&type=template&id=5a14fcb0&scoped=true"
import script from "./JeecgOrderModalForJVexTable.vue?vue&type=script&lang=js"
export * from "./JeecgOrderModalForJVexTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a14fcb0",
  null
  
)

export default component.exports